import React from "react";
import { useLang } from "../i18n";
import { ArrowRight } from "lucide-react";

export default function Services() {
  const { t } = useLang();
  return (
    <section id="services" data-testid="services-section" className="py-24 md:py-36 border-t border-gt-cream/8">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-7">
            <div className="section-eyebrow mb-6">
              <span className="gt-eyebrow">{t.services.eyebrow}</span>
            </div>
            <h2 className="gt-display text-gt-cream text-4xl md:text-6xl lg:text-7xl">
              {t.services.title_a} <span className="text-gt-cream/55 gt-display-light">{t.services.title_em}</span>
            </h2>
          </div>
          <div className="lg:col-span-5 flex items-end">
            <p className="text-base md:text-lg text-gt-ink/75 leading-relaxed">{t.services.subtitle}</p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-gt-cream/8">
          {t.services.cards.map((c, i) => (
            <div
              key={i}
              data-testid={`service-card-${i + 1}`}
              className="gt-card p-8 md:p-10 min-h-[240px] flex flex-col"
            >
              <div className="flex items-start justify-between mb-6">
                <span className="font-display text-xl text-gt-cream/50">0{i + 1}</span>
                <span className="w-8 h-px bg-gt-cream/40" />
              </div>
              <h3 className="font-display text-2xl md:text-[1.6rem] text-gt-cream uppercase leading-tight mb-3">{c.t}</h3>
              <p className="text-sm md:text-base text-gt-ink/70 leading-relaxed mt-auto">{c.d}</p>
            </div>
          ))}
        </div>

        <div className="mt-14 flex flex-col sm:flex-row items-start sm:items-center gap-5 sm:gap-8 border-t border-gt-cream/8 pt-10">
          <p className="text-gt-cream/85 text-lg md:text-xl font-body">{t.services.cta}</p>
          <a
            href="#contact"
            data-testid="services-cta"
            className="inline-flex items-center gap-3 px-6 py-3 text-[0.7rem] btn-cream"
          >
            {t.nav.cta} <ArrowRight size={14} />
          </a>
        </div>
      </div>
    </section>
  );
}
